import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Toast } from 'antd-mobile';
import reporting_body from '../../static/images_ae/reporting/reporting_body.png';
import area_head from '../../static/images_ae/reporting/area_head.png';
import line_head from '../../static/images_ae/reporting/line_head.png';
import area_chest from '../../static/images_ae/reporting/area_chest.png';
import line_chest from '../../static/images_ae/reporting/line_chest.png';
import area_stomach from '../../static/images_ae/reporting/area_stomach.png';
import line_stomach from '../../static/images_ae/reporting/line_stomach.png';
import area_others from '../../static/images_ae/reporting/area_others.png';
import line_others from '../../static/images_ae/reporting/line_others.png';
import line_heart from '../../static/images_ae/reporting/line_heart.png';
import line_lungs from '../../static/images_ae/reporting/line_lungs.png';
import area_four_limbs from '../../static/images_ae/reporting/area_four_limbs.png';
import line_four_limbs from '../../static/images_ae/reporting/line_four_limbs.png';
import tip_top_select from '../../static/images_ae/reporting/tip_top_select.png';
import sympton_bg from '../../static/images_ae/reporting/sympton_bg.png';
import bg_back from '../../static/images_ae/reporting/bg_back.png';
import bg_finish_go_on from '../../static/images_ae/reporting/bg_finish_go_on.png';
import tip_bottom_select from '../../static/images_ae/reporting/tip_bottom_select.png';
import organ_liver from '../../static/images_ae/reporting/organ_liver.png';
import organ_belly from '../../static/images_ae/reporting/organ_belly.png';
import organ_kidney from '../../static/images_ae/reporting/organ_kidney.png';
import line_liver from '../../static/images_ae/reporting/line_liver.png';
import line_belly from '../../static/images_ae/reporting/line_belly.png';
import line_kidney from '../../static/images_ae/reporting/line_kidney.png';
import { withRouter } from 'react-router-dom';
import styles from './stomach.module.scss';

const api = new ApiCore();

const Chest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [headSelected, setHeadSelected] = useState<any>(false);
    const [chestSelected, setChestSelected] = useState<any>(false);
    const [stomachSelected, setStomachSelect] = useState<any>(false);
    const [othersSelected, setOthersSelected] = useState<any>(false);
    const [fourLimbsSelected, setFourLimbsSelected] = useState<any>(false);
    const [selectedCount, setSelectedCount] = useState<any>(0);
    const [organs, setOrgans] = useState<any>(props.organs || {});
    const [organList, setOrganList] = useState<any>([]);
    const [symptoms, setSymptoms] = useState<any>([]);
    const [activeOrgan, setActiveOrgan] = useState<any>('liver');

    useEffect(() => {
        window.document.title = 'ALK风险评估';
        initData();
        return () => {
            window.removeEventListener('popstate', onPopState);
        }
    }, [])

    useEffect(() => {
        let _selectedCount = 0;
        [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected].forEach((val: any) => {
            if (val) {
                _selectedCount++;
            }
        })
        setSelectedCount(_selectedCount);
    }, [headSelected, chestSelected, stomachSelected, othersSelected, fourLimbsSelected])

    const initData = () => {
        window.addEventListener('popstate', onPopState)
        let _list = organs.organs || []
        if (_list) {
            setOrganList(_list);
        }
    }

    const headSelect = () => {
        setHeadSelected(!headSelected);
        setChestSelected(false);
        setStomachSelect(false);
        setActiveOrgan('liver');
    }

    const chestSelect = () => {
        setChestSelected(!chestSelected);
        setHeadSelected(false);
        setStomachSelect(false);
        setActiveOrgan('kidney');
    }

    const stomachSelect = () => {
        setStomachSelect(!stomachSelected);
        setChestSelected(false);
        setHeadSelected(false);
        setActiveOrgan('stomach');
    }

    const othersSelect = () => {
        setOthersSelected(!othersSelected);
    }

    const fourLimbsSelect = () => {
        setFourLimbsSelected(!fourLimbsSelected);
    }

    const symptomsSelected = (val: any, key: number) => {
        const _list = organList.map((item: any) => {
            let _symptoms: any = item.symptoms.map((v: any) => {
                let _selected = !!v.selected;
                if (val.code === v.code) {
                    _selected = !v.selected;
                }
                return {
                    ...v,
                    selected: _selected
                }
            });
            return {
                ...item,
                symptoms: _symptoms
            }
            // let selected = !!item.selected;
            // if (val.code === item.code) {
            //     selected = true;
            // }
            // return {
            //     selected: selected,
            //     ...item
            // }
        });
        setOrganList(_list);
    }

    const onPopState = (event: any) => {
        props.onBack();
    }

    return (
        <div className={styles.ae_reporting}>
            {/* <div className={styles.tip_top_wrap}>
                <img className={styles.tip_top} src={tip_top_select} alt="" />
                <div className={styles.tip_top_text}>请从下列5个部位中选择您出现不适的部位</div>
            </div> */}
            <div className={styles.area_body_container}>
                <img className={styles.area_body} src={reporting_body} alt="" />
                <div className={`${styles.area_base} ${styles.area_head} ${headSelected ? styles.area_active : ''}`} onClick={ () => { headSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_liver} alt="" />
                        <div>肝脏</div>
                    </div>
                    <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括精神方面、五官等部位
                    </div>
                    <img  className={styles.line_head} src={line_liver} alt="" />
                </div>
                <div className={`${styles.area_base} ${styles.area_chest} ${chestSelected ? styles.area_active : ''}`} onClick={ () => { chestSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_kidney} alt="" />
                        <div>肾脏</div>
                    </div>
                    <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div>
                    <img  className={styles.line_chest} src={line_kidney} alt="" />
                </div>
                <div className={`${styles.area_base} ${styles.area_others} ${stomachSelected ? styles.area_active : ''}`} onClick={ () => { stomachSelect()} }>
                    <div className={`${styles.area_tl_l}`}></div>
                    <div className={`${styles.area_tl_t}`}></div>
                    <div className={`${styles.area_tr_r}`}></div>
                    <div className={`${styles.area_tr_t}`}></div>
                    <div className={`${styles.area_bl_l}`}></div>
                    <div className={`${styles.area_bl_b}`}></div>
                    <div className={`${styles.area_br_r}`}></div>
                    <div className={`${styles.area_br_b}`}></div>
                    <div className={styles.area_head_top}>
                        <img className={styles.icon_head} src={organ_belly} alt="" />
                        <div>肠胃</div>
                    </div>
                    <div className={styles.area_head_middle}>
                    </div>
                    <div className={styles.area_head_bottom}>
                        包括心脏、肺部等器官
                    </div>
                    <img  className={styles.line_others} src={line_belly} alt="" />
                </div>
            </div>
            <div className={styles.sympton_select}>
                <div className={styles.sympton_select_img_wrap}>
                    <img src={sympton_bg} alt="" />
                </div>
                <div className={styles.sympton_select_text_wrap}>
                    <div className={styles.sympton_select_text}>请选择一个或多个与您症状贴近的病症描述：</div>
                    <div className={styles.sympton_select_menu}>
                        {/* <div className={styles.menu_active}>心悸</div> */}
                        {
                            organList.map((val: any, key: number) => {
                                if (activeOrgan === val.type) {
                                    return val.symptoms.map((val: any, iKey: number) => (
                                        <div key={iKey} className={`${val.selected ? styles.menu_active : ''}`} onClick={() => { symptomsSelected(val, key) }}>{val.name}</div>
                                    ))
                                }
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.btns_wrap}>
                <div className={styles.btns_back}>
                    <img className={styles.bootom_top} src={bg_back} alt="" />
                    <div className={styles.text} onClick={() => { props.onBack() }}>返回上一步</div>
                </div>
                <div className={styles.btns_finish_go_on}>
                    <img className={styles.bootom_top} src={bg_finish_go_on} alt="" />
                    <div className={styles.text} onClick={() => { window.history.go(-1); props.onComplete('abdomen', organList) }}>选择完成，继续评测</div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Chest);